export function safeImageUrl(url: string): string {
  if (!url) return url;
  try {
    return encodeURI(decodeURI(url));
  } catch {
    return url;
  }
}
